export default {
  DEFAULT: "/",
  LOGIN: "/login/",
  LOGOUT: "/logout/",
  TOP_PAGE: "/home/",
  POINT_CONFIRMATION: "/point-confirmation/",
  DETAILS_GRANT_POINTS: "/point-confirmation/details-grant-points/",
  DETAILS_GRANT_THANKS: "/point-confirmation/details-grant-thanks/",
  DETAILS_THANKS: "/point-confirmation/details-thanks/",
  DETAILS_EXCHANGE: "/point-confirmation/details-exchange/",
  EXPIRING_POINTS: "/point-confirmation/expiring-points/",
  EXPIRING_POINT_DETAILS: "/point-confirmation/expiring-point-details/",
  EXPIRED_POINTS: "/point-confirmation/expired-points/",
  EXPIRED_POINT_DETAILS: "/point-confirmation/expired-point-details/",
  GRANT_CRITERIA: "/grant-criteria/",
  GRANT_CRITERIA_DETAILS: "/grant-criteria/details/",
  THANKS_POINT: "/thanks-point/",
  THANKS_POINT_MESSAGES: "/thanks-point/message/",
  THANKS_POINT_USER_SPECIFIC: "/thanks-point/user-specific/",
  THANKS_POINT_USER_SELECTION: "/thanks-point/user-selection/",
  THANKS_POINT_GIVE_THANKS_POINT: "/thanks-point/give-thanks-point/",
  WHATS_NEW: "/whats-new/",
  WHATS_NEW_DETAILS: "/whats-new/details/",
  // CMS_SPECIAL_PAGE: "/specialPage/",
  CMS_SPECIAL_PAGE_DETAIL: "/specialPage/detail/",
  PRODUCT: "/product/",
  PRODUCT_LIST_LIFE: "/product/list-life/",
  PRODUCT_DETAIL_LIFE: "/product/detail-life/",
  PRODUCT_ORDER: "/product/order/",
  PRODUCT_LIST_XXX: "/product/list-xxx/",
  PRODUCT_DETAIL_XXX: "/product/detail-xxx/",
  PRODUCT_ORDER_2: "/product/order/",
  MY_PAGE: "/my-page/", // TODO temp
  // MY_PAGE: "https://mypage.incp.tst.benefit-one.inc/mypage/",
  MY_PAGE_COUPON:
    " https://mypage.ic.tst.benefit-one.inc/mypage/coupon?sort=ticketDate/",
  MY_PAGE_ORDERS_SHOP: "https://mypage.incp.tst.benefit-one.inc/mypage/orders/",
  MY_PAGE_ORDERS_LIFE: "https://mypage.incp.tst.benefit-one.inc/mypage/orders/",
  MY_PAGE_SETTING: "https://mypage.incp.tst.benefit-one.inc/mypage/setting/",
  MAIL_DELIVERY_SETTINGS: "/mail-delivery-settings/",
  CONTACT_FORM:
    process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html",
  FAQ: process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/incentive/faq3/"
};
